module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notification",
    class: [_vm.type, _vm.icon ? 'lg' : 'sm']
  }, [(_vm.icon) ? _c('y-svg', {
    staticClass: "notification-info",
    attrs: {
      "type": _vm.svgClass,
      "width": 38
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "notification-c"
  }, [_c('h2', {
    slot: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    slot: "description"
  }, [_vm._v(_vm._s(_vm.content))])]), _vm._v(" "), _c('y-svg', {
    staticClass: "ion-close-round notification-del",
    attrs: {
      "type": "x",
      "width": 18
    },
    nativeOn: {
      "click": function($event) {
        _vm.close($event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-146aca16!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/notification/notify.vue
// module id = 452
// module chunks = 27